/**
 * Einstellungen für das PieChartOverview-Widget
 */
import React, { useState, useEffect } from 'react';

const PieChartOverviewSettings = ({ config, onChange }) => {
  const [settings, setSettings] = useState({
    title: config.title || 'Untersuchungen Übersicht',
  });

  useEffect(() => {
    // Aktualisiere den State wenn sich die config ändert
    setSettings({
      title: config.title || 'Untersuchungen Übersicht',
    });
  }, [config]);

  const handleTitleChange = (e) => {
    const newTitle = e.target.value;
    setSettings(prevSettings => ({
      ...prevSettings,
      title: newTitle
    }));
    if (onChange) {
      onChange({
        ...config,
        title: newTitle
      });
    }
  };

  return (
    <div className="pie-chart-overview-settings">
      <h3>Einstellungen für Pie Chart Overview</h3>
      <div className="form-group">
        <label htmlFor="widget-title">Widget Titel:</label>
        <input
          id="widget-title"
          type="text"
          className="form-control"
          value={settings.title}
          onChange={handleTitleChange}
        />
      </div>
    </div>
  );
};

export default PieChartOverviewSettings;
